/**
 * Participant Role Enum
 */
export var ParticipantRole;
(function (ParticipantRole) {
    ParticipantRole["HIDER"] = "hider";
    ParticipantRole["HUNTER"] = "hunter";
    ParticipantRole["SPECTATOR"] = "spectator";
})(ParticipantRole || (ParticipantRole = {}));
//# sourceMappingURL=participant.js.map